import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import api from "@/utils/api";
import cookie from "@/utils/cookie";
import VueSanitize from "vue-sanitize";
import * as Sentry from "@sentry/vue";
import { AUTH_REQUEST_IFRAME } from "@/store/actions/auth.js";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import i18n from "@/utils/translations";
import numero from "../node_modules/numbro/dist/numbro.min.js";
import "@/utils/directives";
import { BrowserTracing } from "@sentry/tracing";

const moment = require("moment");
require("moment/min/locales.min");

Vue.use(require("vue-moment"), {
  moment,
});

Vue.component(VueQrcode.name, VueQrcode);
Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["*"],
      // tracePropagationTargets: ["localhost", "my-site-url.com", /^\//],
    }),
  ],
  enabled: process.env.VUE_APP_NODE_ENV !== "TESTING",
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

Vue.config.performance = true;
Vue.config.productionTip = false;

const token = cookie.getCookie("user-token");
if (token) {
  api.service.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

Vue.use(VueSanitize);
Vue.use(numero);

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
